<!-- 自動サインイン用のページなのでローディング画像以外何も記述しない -->
<div *ngIf="isLoading" class="loading-area-lg">
  <app-loading></app-loading>
</div>
